/**
 * Extract the trailing numeric product ID from a slug.
 *
 * Per `docs/product_intro_search_api.md` §8.4, all Calebasse product slugs
 * end with a 3–5 digit numeric ID (e.g. `gui-hua-olivier-odorant-3794`).
 * We use this to derive a product_id when only the slug is available
 * (the overview search endpoint returns slug only, not numeric id).
 *
 * @returns the numeric ID as a string, or null if not extractable.
 */
export function productIdFromSlug(slug: string): string | null {
  if (typeof slug !== 'string' || slug.length === 0) return null;
  const match = slug.match(/-(\d{3,})$/);
  return match ? match[1] : null;
}

